import { useState, useEffect } from "react";

const TextQuestion = ({ question, responses, saveResponse, compact }) => {

    const [value, setValue] = useState("");

    const onTextBlur = (questionId, value) => {
        console.log(`questionId: ${questionId} value: ${value}`);

        const params = {
            surveyQuestionId: question.surveyQuestionId,
            questionId: parseInt(questionId, 10),
            textResponse: value
        }
        saveResponse(params);
        // console.log(params);
    }

    useEffect(() => {
        let value = "";
        for (let response of responses) {
            if (response.questionId === question.questionId) {
                value = response.response;
                break;
            }
        }
        console.log(`setting textResponse to ${value}`);
        setValue(value);
    }, [question, responses])


    return (
        <div className={`${compact ? "compact" : ""} text-input`}>
            <input className={`${compact ? "compact" : ""} wide`} type="text" id={question.questionId} name={question.questionId} maxLength={question.maxLength} autoComplete="off" value={value} onChange={(e) => setValue(e.target.value)} onBlur={(e) => onTextBlur(question.questionId, e.target.value)} />
        </div>
    )

};


export default TextQuestion;